// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"16243a59","189":"810a5aa0","232":"2d59ffd5","464":"7002cf1a","685":"827f8ae3","866":"155894ce"}[chunkId] + ".chunk.js";
};